// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

//  const firebaseConfig = {
//    apiKey: "AIzaSyAR8U6aCV8YIGs_VCz2bY3venO9194yD_U",
//    authDomain: "my-first-project-cebc3.firebaseapp.com",
//    databaseURL: "https://my-first-project-cebc3-default-rtdb.firebaseio.com",
//    projectId: "my-first-project-cebc3",
//    storageBucket: "my-first-project-cebc3.appspot.com",
//    messagingSenderId: "15531968272",
//    appId: "1:15531968272:web:8d2ec27e043cbe187c8795",
//    measurementId: "G-98KXM33BE0"
//  };

 const firebaseConfig = {
   apiKey: "AIzaSyByffENWQhlg9RqOtpCzDaeUHUjH4Jbwuc",
   authDomain: "blackstone-c21b7.firebaseapp.com",
   databaseURL: "https://blackstone-c21b7-default-rtdb.firebaseio.com",
   projectId: "blackstone-c21b7",
   storageBucket: "blackstone-c21b7.firebasestorage.appspot.com",
   messagingSenderId: "1099000632711",
   appId: "1:1099000632711:web:016c3cd21cc3ae9796ef22"
 };

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getDatabase(app);
const storage = getStorage(app); // ✅ Pass app explicitly

export { auth, db, storage };
  